import React from 'react';
import PageList from '../../components/PageListAPI'
import { moveStorage } from '../../api/inventory'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
export default function InventoryMoveStorage(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='position'
        title='Переместить инвентарные объекты на склад'
        columns={[
          { id: 'id', name: 'Номер' },
          { id: 'userName', name: 'Добавил' },
          { id: 'storageName', name: 'Склад' },
        ]}
        createItem={can(SLUGS.STORAGE.INVENTORY.MOVE_MANAGE)}
        deleteItem={can(SLUGS.STORAGE.INVENTORY.MOVE_MANAGE)}
        loadAPI={{
          request: moveStorage.getList,
          querty: {
            idProject: props.match.params.idProject
          }
        }}
        click={false}
        deleteAPI={moveStorage.deleteById}
        {...props}
      />
    </div>
  )
};